module.exports = __webpack_public_path__ + "static/media/om.b705fe37.png";